import { useState } from 'react'

import {
  LoadingContainer,
  Model,
  Input,
  Button,
  NumericInput,
} from 'peach/components'
import { useParams } from 'peach/router'
import { LoanFeeTypeSelect } from 'peach/scopes/loan'

import { useInternalFeesPost } from 'core/types'

const LoanFeeForm = ({ value, loanTypeId }) => {
  const { companyId, personId, loanId } = useParams<{
    companyId?: string
    personId?: string
    loanId?: string
  }>()

  const [preview, setPreview] = useState(null)

  const {
    mutateAsync: chargeFee,
    isPending,
    error,
  } = useInternalFeesPost({
    companyId,
    personId,
    loanId,
  })

  return (
    <LoadingContainer error={error} loading={isPending}>
      <LoanFeeTypeSelect formKey='apiName' loanTypeId={loanTypeId} />

      <NumericInput formKey='feeAmount' />

      <Input formKey='caseId' />

      <Button
        onClick={async () => {
          const resp = await chargeFee({ previewMode: true, ...value })
          setPreview(resp)
        }}
      >
        Preview
      </Button>

      <Model.Item json={preview} />
    </LoadingContainer>
  )
}

export default LoanFeeForm
